import { appCertification } from "./AppCertification";

import { i18n } from "@/lang/lang.js";
// コメント位置はPrettier対策
class AppConfig {
  //FIXME 本番設定に書き換えてください。
  /**
   * アプリケーションの定数値です。
   */
  APP_CONFIG = {
    MOCK_MODE: false,
    BASE_URL: appCertification.APP_CONFIG.BASE_URL,
  };
  /**
   * APIのURLです。
   */
  API_URL = {
    /**  認証情報取得 */
    MST_AUTH_INFO: "master/a-auth-info",
    /**  ユーザ情報マスタ */
    MST_USERINFO: "master/user-informations",
    /**  納期回答算出一覧取得 */
    BIZ_GROUP_REQUESTS_SEARCH: "business/a-group-requests-search",
    /**  納期回答算出一覧更新 */
    BIZ_GROUP_REQUESTS_UPDATE: "business/a-group-requests-update",
    /**  輸送依頼データ一覧取得*/
    BIZ_NO_GROUP_REQUESTS_SEARCH: "business/a-NoGrouptrpReqDataList-search",
    /** 納期回答算出 */
    BIZ_GROUP_REQUESTS_CALCULATE: "business/a-delivery-date-calculation",
    /** 納期回答解除（グループ内一括解除） */
    BIZ_DELI_DATE_CANCEL_GROUP: "business/a-delivery-date-cancel-group",
    /**  拠点情報取得 */
    MST_BASES: "master/a-bases",
    /** ルートパターン一覧取得 */
    MST_ROUTE_PATTERNS: "master/a-route-patterns",
    /** エリア情報取得 */
    MST_AREAS: "master/a-areas",
    /** 車種情報取得 */
    MST_CAR_TYPES: "master/a-car-types",
    /** コードマスタ */
    MST_CODES: "master/codes",
    /** グループ一覧取得 */
    BIZ_GROUP_SEARCH: "business/a-groupList-search",
    /** グループ削除 */
    BIZ_GROUP_DELETE: "business/a-groupDelete-register",
    /** 納期確定 */
    BIZ_DELIVERY_DATE_FIX: "business/a-fix-delivery-date",
    /** 納期ルートデータファイルダウンロード */
    BIZ_DELIVERY_DATE_FILE_DOWNLOAD: "business/a-out-delivery-date-route-file",
    /** 依頼元情報取得 */
    MST_CUSTOMERS: "master/a-trpOrderList-search",
    /** すべての依頼元情報取得 */
    MST_ALL_CUSTOMERS: "master/a-all-customers",
    /** グループ未設定輸送依頼データ取得 */
    BIZ_TRPREQDATA_LIST_SEARCH: "business/a-NoGrouptrpReqDataList-search",
    /** グループ登録 */
    BIZ_GROUP_REGISTER: "business/a-group-register",
    /** お知らせ一覧取得 */
    BIZ_NOTICES: "business/a-notices",
    /** 納期明細一覧取得 */
    BIZ_DELI_DETAIL_LIST_SEARCH: "business/a-deli-ans-detailList-search",
    /** 輸送能力ダウンロード */
    BIZ_DELI_CAPACITY_DOWNLOAD: "business/a-download-transport-capacity",
    /** 輸送能力アップロード */
    BIZ_DELI_CAPACITY_UPLOAD: "business/a-upload-transport-capacity",
    /** 休業日情報取得 */
    BIZ_BASE_CLOSED_DAY_SEARCH: "business/a-base-closed-day-search",
    /** 休業日情報登録 */
    BIZ_UPDATE_CLOSED_DAY: "business/a-base-closed-day-update",
  };
  MENU_ID = {
    /** ホーム */
    M_HOM: "P-MENU-000",
    /** グループ設定 */
    M_INI_GROUP_SETTING: "P-DDA-001",
    /** グループ一覧 */
    M_INI_GROUP_LIST: "P-DDA-002",
    /** 輸送依頼データ追加 */
    M_INI_TRANSPORT_REQUEST: "P-DDA-003",
    /** 納期回答算出一覧 */
    M_INI_DELI_DATE_ANS_CALC_LIST: "P-DDA-004",
    /** ルート選択 */
    M_INI_ROUTE_SELECT: "P-DDA-005",
    /** 輸送能力一括登録 */
    M_INI_DELI_CAPACITY_UPLOAD: "P-DDA-009",
    /** 休業日登録 */
    M_INI_CLOSED_DAY_UPDATE: "P-DDA-010",
  };

  /**
   * ボタン制御用ID
   */
  BTN_AUTHORITY_ID = {
    /** 在庫引当遷移ボタン(ダイアログ) */
    P_STK_INVEN_ALLOC_RESERVE: "P-SHP-001_RESERVE",
  };

  /**
   * 画面IDです。
   */
  SCREEN_ID = {
    /** ログイン */
    P_COM_001: "P_COM_001",

    /** グループ設定 */
    P_DDA_001: "P-DDA-001",
    /** グループ一覧 */
    P_DDA_002: "P-DDA-002",
    /** 納期回答算出一覧 */
    P_DDA_003: "P-DDA-003",
    /** 輸送依頼データ追加 */
    P_DDA_004: "P-DDA-004",
    /** ルート選択 */
    P_DDA_005: "P-DDA-005",
    /** 納期回答明細一覧 */
    P_DDA_007: "P-DDA-007",
    /** 輸送能力一括登録 */
    P_DDA_009: "P-DDA-009",
    /** 休業日登録 */
    P_DDA_010: "P-DDA-010",
  };

  STATUS_CODE = {
    //グループ設定済み
    CONFIGURED: "01",
    //納期回答算出済み
    ANSWERED: "02",
    //確定済み
    FIXED: "03",
    //ダウンロード済み
    DOWNLOADED: "04",
  };
  /**
   * 輸送会社区分
   */
  CARRIERCOMPDIV = {
    // 社有
    OWNED: "01",
    // グループ会社
    GROUP: "02",
    // 協力会社
    COOP: "03",
    //路線
    DELIVERY: "04",
  };

  /**
   * 更新トークン
   */
  UPDATE_TOKEN = {
    /**
     * 分
     */
    tokenTimeOut: 1439,
  };

  /**
   * ダイアログ
   */
  DIALOG = {
    /**
     * タイトル
     */
    title: i18n.t("label.lbl_result"),
    confirm: i18n.t("btn.btn_ok"),
  };

  /**
   * コードマスタ種別
   */
  CODETYPE = {
    STATUS: "0401",
    CAPACITY_DOWNDLOAD: "9201",
    TMP_CLOSED_DAY_PAST_DAYS: "9301",
  };
  API_ERROR_MSG_ID = {
    /**  排他DB更新失敗エラー */
    A_999_999_020_E: "A-999-999_020_E",
  };
  /**
   * 業務利用関係先マスタ
   */
  ISGETCLIENT = {
    /** 取引先 */
    CLIENT: "1",
    /** FromもしくはTo */
    FROMTO: "0",
  };
  /**
   * 定数
   */
  CONSTANT = {
    /** 文字コード */
    CHARSET: {
      SHIFT_JIS: "shift_jis",
      UTF_8: "utf-8",
    },
    /** 画面クリア時のメッセージID */
    CLEAR_MESSAGE: "P-COM-001_006_C",
  };
  RESCOMCODE_SUCCESS = "000";
  CNTCHARITEM = 3;
  CNTCHARLOCATION = 3;
  CNT_CHAR_RELATED_PARTY = 2;
  /**
   * ソート
   */
  SORT = {
    P_DDA_002_SORT: {
      transportRequestUpdateInfo: "transport_request_update_info {0}",
      statusName: "status_div {0}",
      referenceDate: "reference_date {0}",
      minRequestDate: "group_min_store_delivery_request_date {0}",
      confirmedDate: "confirmed_date {0}",
      lastGroupSetUserName: "last_group_set_user_id {0}",
    },
    P_DDA_004_SORT: {
      shipNo: 'in_list_no COLLATE "ja_JP.utf8" {0}',
      arrivalScheduleDate: "in_schedule_date {0}",
      isPaid: "free_cost_div {0}",
      inStock: "complete_flg {0}",
      processDivName: "process_div_name {0}",
      arrivalto: "from_name {0}",
      howtoregister: "entry_div {0}",
    },
  };

  TEST_PROPERTY_CD = {
    /** テキスト */
    TEXT: "100",
    /** 合否、テキスト */
    PASS_FAIL_TEXT: "101",
    /** 日付 */
    DATE: "110",
    /** 整数 */
    INTEGER: "120",
    /** 合否、整数 */
    PASS_FAIL_INTEGER: "121",
    /** 合否、整数、小数点1 */
    PASS_FAIL_INTEGER_DECIMAL_POINT1: "130",
    /** 合否、整数、小数点2 */
    PASS_FAIL_INTEGER_DECIMAL_POINT2: "131",
    /** レ点 */
    SCORE: "140",
    /** 合否 */
    PASS_FAIL: "142",
    /** 電子印 */
    ELECTRONIC_SEAL: "900",
  };
  /**
   * 加工計画一覧 計画区分
   */
  PLANNING_SECTION_DIV = {
    // 出荷
    SHIPPING: "01",
    // 入荷
    ARRIVAL: "02",
    // 加工
    DISTRIBUTION: "03",
  };
  /**
   * ファイル制限サイズ
   */
  FILE_LIMIT_SIZE = {
    /** 作業進行表の取込ファイル：100MB */
    WORK_PROGRESS_IMPORT_FILE: {
      VALUE: 1024 * 1024 * 100,
      MESSAGE: "100MB",
    },
  };
  /**
   * PC画面制御マスタで使用するKEY
   */
  PC_DISP_COUT = {
    ATTACH_RESOURCE_KEY: {
      A_COM_001: "A-COM-001",
    },
    ITEM01: {
      ARRIVED_ITEMS_SUBJECT_INVENTORY_COUNT: "ArrivedItemsSubjectInventoryCount",
      DIRECT_BRING_CATEGORY: "directBringCategory",
    },
  };

  /**
   * StepFunctionsのエラーステータス
   */
  STEP_FUNCTIONS_STATES_ERRORS = {
    DATA_LIMIT_EXCEEDED: "States.DataLimitExceeded",
    TIMEOUT: "States.Timeout",
  };
}

export const appConfig = new AppConfig();
